import { j as e } from "./jsx-runtime-e6RZPHeG.js";
import { memo as s } from "react";
const r = ({
  title: l,
  titleId: c,
  ...o
}) => /* @__PURE__ */ e.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 1024 1024",
    role: "img",
    "aria-labelledby": c,
    ...o,
    children: [
      l ? /* @__PURE__ */ e.jsx("title", { id: c, children: l }) : null,
      /* @__PURE__ */ e.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M823.324 341.702H404.977c-22.037 0-39.872-19.115-39.872-42.667s17.835-42.667 39.872-42.667h418.347c22.016 0 39.851 19.115 39.851 42.667s-17.835 42.667-39.851 42.667m0 164.48H404.977c-22.037 0-39.872-19.115-39.872-42.667s17.835-42.667 39.872-42.667h418.347c22.016 0 39.851 19.115 39.851 42.667s-17.835 42.667-39.851 42.667m0 164.502H404.977c-22.037 0-39.872-19.136-39.872-42.667 0-23.573 17.835-42.667 39.872-42.667h418.347c22.016 0 39.851 19.093 39.851 42.667 0 23.531-17.835 42.667-39.851 42.667m0 164.48H404.977c-22.037 0-39.872-19.136-39.872-42.667 0-23.573 17.835-42.667 39.872-42.667h418.347c22.016 0 39.851 19.093 39.851 42.667 0 23.531-17.835 42.667-39.851 42.667M235.637 405.338c-11.797 0-21.333-9.557-21.333-21.333V274.202l-21.781 21.099c-8.619 8.363-22.421 7.936-30.507-.939l-7.125-7.808c-7.765-8.512-7.339-21.653.981-29.653l61.376-58.944c3.947-3.819 9.259-5.952 14.763-5.952h26.965c11.776 0 21.333 9.536 21.333 21.333v170.667c0 11.776-9.557 21.333-21.333 21.333z",
          clipRule: "evenodd"
        }
      )
    ]
  }
), n = s(r);
export {
  n as default
};
